export enum MediaQueriesColorSchemes {
  DARK_MODE = '(prefers-color-scheme: dark)',
}

export enum MediaQueriesOrientation {
  PORTRAIT = '(orientation: portrait)',
  LANDSCAPE = '(orientation: landscape)',
}
